import { SmartTable } from '../../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, Alert, GroupsResource) {
        this.$state = $state;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
    }

    $onInit() {
        this.st = new SmartTable();
    }

    assign() {
        this.isSaving = true;
        this.GroupsResource
            .assignGroupToApplication(this.companyId, this.group.id, this.st.selectedIds)
            .then(() => this.$state.go('^', {}, {reload: '^'}))
            .then(() => this.Alert('success', 'company.user-directories.manage-group.applications.assign.assigned'))
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/applications/assign/assign-group-to-application.controller.js